import { SignUp } from "@clerk/clerk-react";

export default function SignUpPage() {
  return (
    <div className="container-page flex justify-center py-16">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        fallbackRedirectUrl="/dashboard"
        appearance={{
          variables: {
            colorPrimary: "#f5b14a",
            colorBackground: "#0f172a",
            colorText: "#e2e8f0",
            colorInputBackground: "#0b1220",
            colorInputText: "#f8fafc",
          },
        }}
      />
    </div>
  );
}
